import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { TOKEN_CONSTANTS } from '../../constant';
import { getLocalStorage } from '../../helpers/localstorage-utils';

const quizAssessmentBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL,
  prepareHeaders: (headers: Headers) => {
    const token = getLocalStorage(TOKEN_CONSTANTS.QUIZ);
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  }
});

export default quizAssessmentBaseQuery;
